import { Link } from "react-router-dom"
import { User } from "lucide-react"
import { Button } from "@/components/ui/button"
import { NAVIGATION_ROUTES } from '@/constants/routes'

export function DashboardHeader() {
  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="px-8 py-4 flex items-center justify-between">
        {/* Logo - 靠左 */}
        <Link to={NAVIGATION_ROUTES.HOME} className="flex items-center gap-2">
          <div className="w-8 h-8 bg-black rounded-lg flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-white rounded-full" />
          </div>
          <span className="text-lg font-bold text-gray-900">Easy Share</span>
        </Link>

        {/* 右侧导航 */}
        <nav className="flex items-center gap-6">
          <Link to={NAVIGATION_ROUTES.SETTINGS}>
            <Button variant="ghost" size="sm" className="text-gray-700 hover:text-gray-900 h-auto p-0 text-sm font-normal">
              升级会员
            </Button>
          </Link>
          <Link to={NAVIGATION_ROUTES.HISTORY}>
            <Button variant="ghost" size="sm" className="text-gray-700 hover:text-gray-900 h-auto p-0 text-sm font-normal">
              传输历史
            </Button>
          </Link>
          <Link to={NAVIGATION_ROUTES.CLOUD}>
            <Button variant="ghost" size="sm" className="text-gray-700 hover:text-gray-900 h-auto p-0 text-sm font-normal">
              我的云盘
            </Button>
          </Link>
          <Link to={NAVIGATION_ROUTES.SETTINGS}>
            <Button variant="ghost" size="icon" className="text-gray-700 hover:text-gray-900 h-8 w-8 rounded-full">
              <User className="w-4 h-4" />
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  )
}
